export default __webpack_public_path__ + "static/media/cuotaya-logo.52eb2c26.png";